export { useShallowSelector } from '../../../hooks/useShallowSelector';

export const scheduleAWorksheetBodyTextSelector = (state) => ({
  loanbuilderUrl: state.config.loanbuilderUrl,
});
